/**
 * TypewriterJS Frontend Loader
 * * Diese Datei ist für die Initialisierung des Typewriter-Effekts im Frontend zuständig.
 * Sie liest die Konfiguration aus den Data-Attributen aus, die in der render.php
 * gesetzt wurden, und startet die Animation für jede Block-Instanz.
 * * @package gla-block-collection
 * @version 2.21.0
 */

(function () {
	/**
	 * Initialisiert alle Typewriter-Blöcke auf der aktuellen Seite.
	 */
	const initTypewriterBlocks = () => {
		// Suche alle Instanzen des Blocks anhand der CSS-Klasse aus render.php
		const blocks = document.querySelectorAll(".gla-typewriter-text");

		blocks.forEach((block) => {
			const target = block.querySelector(".typewriter-target");
			const configData = block.dataset.config;

			// Sicherheitsprüfung: Ziel-Element vorhanden, Konfiguration vorhanden und Library geladen?
			if (target && configData && typeof Typewriter !== "undefined") {
				try {
					// Parsen der JSON-Konfiguration aus dem HTML-Attribut
					const config = JSON.parse(configData);

					// Initialisierung der Typewriter-Instanz und Start der Animation
					// Die Library wurde via block.json Abhängigkeit (typewriter-library) geladen.
					/* new Typewriter(target, config).start(); */
					new Typewriter(target, {
						...config,
						html: true, // Aktiviert den HTML-Modus im Frontend
					}).start();
				} catch (error) {
					console.error(
						"TypewriterJS: Fehler beim Parsen der Konfiguration für Block:",
						block,
						error,
					);
				}
			}
		});
	};

	/**
	 * Startet die Initialisierung, sobald das DOM vollständig geladen ist.
	 * Dies stellt sicher, dass alle .typewriter-target Elemente im Dokument vorhanden sind.
	 */
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initTypewriterBlocks);
	} else {
		initTypewriterBlocks();
	}
})();
